import { createAction } from "redux-actions";

export const SetSimulationRate = createAction("SET_SIMULATION_RATE");
export const ToggleSimulation = createAction("TOGGLE_SIMULATION");
export const BulkInsert = createAction("TOGGLE_SIMULATION");



// WEBPACK FOOTER //
// ./src/actions/simulation.js